import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WorkOrderListComponent } from "./work-order-list.component";
import { CtModelModule } from "@ctsolution/ct-framework";
import { LangDownloadFileModule } from "../../lang-download-file/lang-download-file.module";
import { WorkOrderDownloadMenuModule } from "../../work-order-download-menu/work-order-download-menu.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatLegacySlideToggleModule } from "@angular/material/legacy-slide-toggle";

/**
 * Module per il componente WorkOrderList
 *
 * Importa sia il modulo legacy LangDownloadFileModule che il nuovo WorkOrderDownloadMenuModule
 * per permettere la compatibilità e il passaggio graduale al nuovo sistema di download
 */
@NgModule({
  declarations: [
    WorkOrderListComponent
  ],
  imports: [
    CommonModule,
    CtModelModule,
    LangDownloadFileModule, // Componente legacy per compatibilità
    WorkOrderDownloadMenuModule ,
    MatLegacySlideToggleModule// Nuovo componente con menu avanzato
  ],
  exports: [
    WorkOrderListComponent
  ]
})
export class WorkOrderListModule {
}
